import { OverviewDashboard } from "@/features/dashboard/overview-dashboard";

export const Route = createFileRoute({
  component: OverviewDashboard,
});
